import React from "react";
import { Snackbar, Alert, SnackbarCloseReason } from "@mui/material";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../app/redux/hooks";
import { hideSnackbar } from "../../../app/slices/common/customSnackBar/customSnackbarSlice";
interface CustomSnackbarProps {
  autoHideDuration?: any;
}
const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  autoHideDuration = 5000,
}) => {
  const dispatch = useDispatch();
  const { open, content } = useAppSelector(
    (state) => state.customSnackbarState
  );

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(hideSnackbar());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={content?.autoHide}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity={content.severity}>
        {content.message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
